import {useAppSelector} from "../storage/hooks";
import {selectGames, selectTrendingGames} from "../storage/slicers/appSlice";
import {Row} from "react-bootstrap";
import Card from "./Card";
import {GAME} from "../storage/constants/properties";
import {AppCardType} from "../storage/types/state_types";

function TrendingApps() {
    const games = useAppSelector(selectGames);
    const array = useAppSelector(selectTrendingGames);
    const trending_games = array.map((id) => games.find((a: AppCardType) => a.id === id));

    return(
        <Row>
            {trending_games.map((game: any) => (
                <Card id={game.id} type={GAME}/>
            ))}
        </Row>
    );
}

export default TrendingApps;